var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelemetry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 4.34977L37.18 1.52977L31.48 7.94977C27.36 3.30977 21.66 0.509766 15.22 0.509766C9.44 0.509766 4.14 2.82977 0 6.50977L2.84 9.34976C6.24 6.36977 10.54 4.50977 15.22 4.50977C20.7 4.50977 25.4 7.02976 28.76 10.9898L23 17.4698L15 9.46976L0 24.4898L3 27.4898L15 15.4698L23 23.4698L31.1 14.3698C32.6 17.0698 33.6 20.1698 33.98 23.4698H38C37.56 18.8698 36.1 14.6898 33.92 11.1898L40 4.34977Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelemetry);
export default __webpack_public_path__ + "static/media/telemetry.d72147bf0ed1ffaccc9732f02fda08db.svg";
export { ForwardRef as ReactComponent };